window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

$(function () {

    let target = $('meta[name="target"]').attr('content')

    if(target){

        switch (target) {
            case 'active-mesh':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-1", offsetY: 0 } });
                break;

            case 'ip55-water-resistance':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-2", offsetY: 0 } });
                break;

            case 'intellectual-property':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-3", offsetY: 0 } });
                break;
        }
    }
})
